module.exports = __webpack_public_path__ + "img/mt3.13c8bbed.jpg";